module.exports = __webpack_public_path__ + "img/t-3.ce9b08a2.png";